const CONTEXT_DEFAULT_VALUE = {
  cardContractId: [],
  cards: [],
  cardsFetching: false,
  currentCard: {},
  selectedCard: null,
  movementsLayoutAllowed: false,
  dashboardLayoutAllowed: false,
  settingsLayoutAllowed: false,
  currentCardDetail: {},
  customerId: null,
  featureFlags: [],
  languagePreference: null,
  localization: {},
  openRequestSignatureModal: false,
  openSKDownloadAppModal: false,
  bannerType: null,
  preapprovalInfo: null,
  flexibleMinimumPaymentInfo: null,
  profile: {},
  setBannerType: (): null => null,
  setCardContractId: (): null => null,
  setCards: (): null => null,
  setCardsFetching: (): null => null,
  setCurrentCard: (): null => null,
  setMovementsLayoutAllowed: (): null => null,
  setDashboardLayoutAllowed: (): null => null,
  setSettingsLayoutAllowed: (): null => null,
  setCurrentCardDetail: (): null => null,
  setCustomerId: (): null => null,
  setFeatureFlags: (): null => null,
  setLanguagePreference: (): null => null,
  setLocalization: (): null => null,
  setOpenRequestSignatureModal: (): null => null,
  setOpenSKDownloadAppModal: (): null => null,
  setPreapprovalInfo: (): null => null,
  setFlexibleMinimumPaymentInfo: (): null => null,
  setProfile: (): null => null,
};

export { CONTEXT_DEFAULT_VALUE };
